import { render, staticRenderFns } from "./BillingREList.vue?vue&type=template&id=22ca78fb&scoped=true&"
import script from "./BillingREList.vue?vue&type=script&lang=js&"
export * from "./BillingREList.vue?vue&type=script&lang=js&"
import style0 from "./BillingREList.vue?vue&type=style&index=0&id=22ca78fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca78fb",
  null
  
)

component.options.__file = "BillingREList.vue"
export default component.exports